export const VACCINE_COLOR_BY_NAME: Record<string, string> = {
  'M痘疫苗': 'bg-gradient-to-r from-pink-500 to-rose-500',
  '卡介苗': 'bg-gradient-to-r from-amber-200 to-yellow-400',
  '肺炎鏈球菌疫苗': 'bg-gradient-to-r from-teal-200 to-teal-500',
  '流感疫苗': 'bg-gradient-to-r from-cyan-500 to-blue-500',
  '常規疫苗': 'bg-gradient-to-r from-fuchsia-600 to-pink-600',
  '新冠肺炎疫苗': 'bg-gradient-to-r from-emerald-500 to-emerald-900',
  'HPV公費疫苗': 'bg-gradient-to-r from-indigo-500 to-purple-500',
};

export const ORGANIZATION_COLOR_BY_NAME: Record<string, string> = {
  '醫院': 'bg-gradient-to-r from-indigo-600 via-indigo-500 to-indigo-400 text-white',
  '西醫': 'bg-gradient-to-r from-green-600 via-green-500 to-green-400 text-white',
  '中醫': 'bg-gradient-to-r from-purple-600 via-purple-500 to-purple-400 text-white',
  '牙醫': 'bg-gradient-to-r from-red-600 via-red-500 to-red-400 text-white',
  '藥局': 'bg-gradient-to-r from-pink-600 via-pink-500 to-pink-400 text-white',
  '中心': 'bg-gradient-to-r from-yellow-600 via-yellow-500 to-yellow-400 text-black',
  '衛生所': 'bg-gradient-to-r from-blue-600 via-blue-500 to-blue-400 text-black',
};

export const BUSINESS_CATEGORY_COLOR_BY_PATH: Record<string, { color: string; badgeColor: string }> = {
  homeMedicalCare: {
    color: 'bg-[#FF6F61]',
    badgeColor: 'bg-gradient-to-r from-red-600 via-red-500 to-red-400 text-white',
  },
  homeDentalCare: {
    color: 'bg-[#6B5B95]',
    badgeColor: 'bg-gradient-to-r from-teal-600 via-teal-500 to-teal-400 text-white',
  },
  homeNursingCare: {
    color: 'bg-[#88B04B]',
    badgeColor: 'bg-gradient-to-r from-cyan-600 via-cyan-500 to-cyan-400 text-white',
  },
  mobilePharmacist: {
    color: 'bg-[#E0978F]',
    badgeColor: 'bg-gradient-to-r from-slate-600 via-slate-500 to-slate-400 text-white',
  },
  mobileDietitian: {
    color: 'bg-[#92A8D1]',
    badgeColor: 'bg-gradient-to-r from-green-600 via-green-500 to-green-400 text-white',
  },
  mobilePsychologist: {
    color: 'bg-[#955251]',
    badgeColor: 'bg-gradient-to-r from-pink-600 via-pink-500 to-pink-400 text-white',
  },
  mobileRehabilitation: {
    color: 'bg-[#B565A7]',
    badgeColor: 'bg-gradient-to-r from-yellow-600 via-yellow-500 to-yellow-400 text-black',
  },
  homeServices: {
    color: 'bg-[#009B77]',
    badgeColor: 'bg-gradient-to-r from-purple-600 via-purple-500 to-purple-400 text-white',
  },
};

export const ROLE_BG_GRADIENT_BY_VALUE: Record<string, string> = {
  god: 'bg-gradient-to-r from-yellow-500 via-yellow-400 to-yellow-300 text-ptTeal',
  admin: 'bg-gradient-to-r from-gray-400 via-gray-300 to-gray-200 text-ptTeal',
  worker: 'bg-gradient-to-r from-orange-700 via-orange-600 to-orange-500 text-gray-200',
  '': 'text-gray-800',
};

export const STATUS_COLOR_BY_NAME: Record<string, string> = {
  processing: 'bg-amber-200 text-amber-700',
  assigned: 'bg-blue-200 text-blue-700',
  accept: 'bg-yellow-200 text-yellow-700',
  completed: 'bg-green-200 text-green-700',
  rejected: 'bg-red-200 text-red-700',
  noDemand: 'bg-gray-400 text-white',
  dead: 'bg-black text-white',
};

export const METRIC_COLOR_BY_KEY: Record<string, string> = {
  bp: 'bg-[#FF6F61]',
  glucose: 'bg-[#6B5B95]',
  temp: 'bg-[#88B04B]',
  pulse: 'bg-[#E0978F]',
  oxygen: 'bg-[#92A8D1]',
};
